import { render } from "./Greeting.vue?vue&type=template&id=39d22fe2&ts=true"
import script from "./Greeting.vue?vue&type=script&lang=ts"
export * from "./Greeting.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__